import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import { Response } from "../interfaces";
import {
  Campaign,
  CreateCampaignDto,
  UpdateCampaignDto,
} from "./campaignTypes";

export const campaignApi = createApi({
  reducerPath: "campaignApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["campaign"],
  endpoints: (builder) => ({
    getCampaignList: builder.query<Response<Campaign[]>, any>({
      query: () => ({
        url: "campaign/list",
        method: "GET",
      }),
      providesTags: ["campaign"],
    }),
    getCampaign: builder.query<Response<Campaign>, string>({
      query: (id) => ({
        url: `campaign/${id}`,
        method: "GET",
      }),
      providesTags: (_result, _error, id) => [{ type: "campaign", id }],
    }),
    createCampaign: builder.mutation<Response<Campaign>, CreateCampaignDto>({
      query: (data) => ({
        url: "campaign/create",
        method: "POST",
        data,
      }),
      invalidatesTags: ["campaign"],
    }),
    updateCampaign: builder.mutation<
      Response<Campaign>,
      { id: string; data: UpdateCampaignDto }
    >({
      query: ({ id, data }) => ({
        url: `campaign/${id}`,
        method: "PATCH",
        data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "campaign", id },
        "campaign",
      ],
    }),
    deleteCampaign: builder.mutation<Response<void>, string>({
      query: (id) => ({
        url: `campaign/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["campaign"],
    }),
    activateCampaign: builder.mutation<Response<Campaign>, string>({
      query: (id) => ({
        url: `campaign/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: "campaign", id },
        "campaign",
      ],
    }),
    deactivateCampaign: builder.mutation<Response<Campaign>, string>({
      query: (id) => ({
        url: `campaign/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: "campaign", id },
        "campaign",
      ],
    }),
  }),
});

export const {
  useGetCampaignListQuery,
  useGetCampaignQuery,
  useCreateCampaignMutation,
  useUpdateCampaignMutation,
  useDeleteCampaignMutation,
  useActivateCampaignMutation,
  useDeactivateCampaignMutation,
} = campaignApi;

